import React, { useState } from 'react';
import { Search, Loader2, Database, AlertCircle } from 'lucide-react';

const AiSearchDashboard = () => {
    const [question, setQuestion] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!question.trim()) return;

        setLoading(true);
        setError(null);
        setData([]);

        try {
            const response = await fetch(`https://api.xilliontech.in/api/v1/nlq/ask?question=${encodeURIComponent(question)}`);
            if (!response.ok) throw new Error("Failed to fetch data from AI service");

            const result = await response.json();
            setData(result);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
            <div className="mb-8 text-center">
                <h1 className="text-3xl font-bold text-gray-800 flex justify-center items-center gap-2">
                    <Database className="text-blue-600" /> AI Management Assistant
                </h1>
                <p className="text-gray-600 mt-2">Ask questions about your EV Workshop in plain English.</p>
            </div>

            {/* Search Input Section */}
            <form onSubmit={handleSearch} className="relative mb-8">
                <input
                    type="text"
                    className="w-full p-4 pr-12 rounded-xl border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="e.g., Show me all active job cards for workers assigned to Tesla models..."
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    disabled={loading}
                />
                <button
                    type="submit"
                    className="absolute right-3 top-3 p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors"
                    disabled={loading}
                >
                    {loading ? <Loader2 className="animate-spin w-5 h-5" /> : <Search className="w-5 h-5" />}
                </button>
            </form>

            {/* Error Message */}
            {error && (
                <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 flex items-center gap-3">
                    <AlertCircle className="text-red-500" />
                    <p className="text-red-700">{error}</p>
                </div>
            )}

            {/* Results Table */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
                {data.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left border-collapse">
                            <thead className="bg-gray-100">
                            <tr>
                                {Object.keys(data[0]).map((key) => (
                                    <th key={key} className="p-4 text-sm font-semibold text-gray-700 uppercase border-b">
                                        {key.replace('_', ' ')}
                                    </th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {data.map((row, i) => (
                                <tr key={i} className="hover:bg-gray-50 border-b last:border-0 transition-colors">
                                    {Object.values(row).map((val, j) => (
                                        <td key={j} className="p-4 text-gray-600 text-sm">
                                            {val === null ? "-" : val.toString()}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ) : !loading && (
                    <div className="p-12 text-center text-gray-400">
                        No results to display. Try asking a question above.
                    </div>
                )}
            </div>
        </div>
    );
};

export default AiSearchDashboard;